import React from "react";
import RaisedButton from "material-ui/RaisedButton";
import colors, { colorsV2 } from "../../styles/colors";
import { Button } from "@material-ui/core";

const style = {
  wrap: {
    margin: 20,
    borderRadius: 7,
    display: "block",
  },
  button: {
    width: 300,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#fff",
    backgroundColor: colors.orange,
    display: "block",
  },
  label: {
    fontSize: 20,
    textTransform: "none",
    color: "white",
  },
};

export default ({ ...props }) => {
  const btnColor =
    !!props.disabled === true
      ? colorsV2.lightCodeGray
      : props.whiteLabelSettings && props.whiteLabelSettings.isWhiteLabel
      ? props.whiteLabelSettings.primaryColor
      : colors.orange;

  let buttonStyle = {
    width: 300,
    height: 50,
    margin: 20,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: "#fff",
    backgroundColor: btnColor,
    display: "block",
  };

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    buttonStyle = {
      width: "100%",
      borderRadius: 7,
      borderWidth: 1,
      borderColor: "#fff",
    };
  }

  return (
    <Button
      style={{ ...buttonStyle, ...style.label }}
      {...props}
      variant="outlined"
    >
      {props.label}
    </Button>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/ActionButton.js